<template>
  <div class="user-studyRecord-view">
    <section class="module">
      <div class="m-body">
        <el-tabs v-model="cycle" @tab-click="typeClick">
          <el-tab-pane name="cycle_0">
            <span slot="label">&nbsp;&nbsp;&nbsp;&nbsp;今天&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <div class="statistic gray">您今天学习了<span class="count red">{{total}}</span>课，共用时<span class="time c21">{{sumTime | timeText}}</span></div>
          </el-tab-pane>
          <el-tab-pane name="cycle_1">
            <span slot="label">&nbsp;&nbsp;&nbsp;&nbsp;本周&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <div class="statistic gray">您本周学习了<span class="count red">{{total}}</span>课，共用时<span class="time c21">{{sumTime | timeText}}</span></div>
          </el-tab-pane>
          <el-tab-pane name="cycle_2">
            <span slot="label">&nbsp;&nbsp;&nbsp;&nbsp;本月&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <div class="statistic gray">您本月学习了<span class="count red">{{total}}</span>课，学习时长<span class="time c21">{{sumTime | timeText}}</span></div>
          </el-tab-pane>
          <el-tab-pane name="cycle_4">
            <span slot="label">&nbsp;&nbsp;&nbsp;&nbsp;全部&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <div class="statistic gray">您累计学习了<span class="count red">{{total}}</span>课，学习时长<span class="time c21">{{sumTime | timeText}}</span></div>
          </el-tab-pane>
        </el-tabs>
        <el-table :data="list" stripe>
          <el-table-column align="center" label="学习时间" prop="createTime">
            <template slot-scope="scope">
              <span>{{scope.row.createTime | dateFormat}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="课程" prop="path"></el-table-column>
          <el-table-column align="center" label="得分" prop="score" width="120"></el-table-column>
          <el-table-column align="center" label="正确率" prop="rate" width="120">
            <template slot-scope="scope">{{scope.row.rate ? (scope.row.rate + '%') : '-'}}</template>
          </el-table-column>
          <el-table-column align="center" label="通过" prop="rate" width="100">
            <template slot-scope="scope">{{scope.row.passed ? '是' : '否'}}</template>
          </el-table-column>
          <el-table-column align="center" label="用时" prop="time" width="150">
            <template slot-scope="scope">
              <span>{{scope.row.time | timeText}}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination v-show="!loading && total > 0" :current-page="pageIndex" :page-size="pageSize" :total="total" :page-sizes="[10, 20]"
          layout="sizes, ->, prev, pager, next, jumper" @size-change="pageSizeChange" @current-change="pageChange" class="mt10">
        </el-pagination>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'studyRecord',
  data () {
    return {
      list: [],
      total: 0,
      sumTime: 0,
      cycle: 'cycle_0',
      pageIndex: 1,
      pageSize: 10
    }
  },
  computed: {
    loading () {
      return this.$store.getters.loading
    }
  },
  created () {
    this.$store.dispatch('setNavigation', [{ name: '个人中心', path: '/user/center' }, { name: '学习记录' }])
    this.getData()
  },
  methods: {
    getData () {
      this.$store.dispatch('setLoading')
      // 获取数据
      this.$http.get(`course/record?cycle=${this.cycle.replace('cycle_', '')}&pageSize=${this.pageSize}&pageIndex=${this.pageIndex}`)
        .then(response => {
          this.$nextTick(() => {
            this.total = response.total
            this.sumTime = response.time
            this.list = response.records
          })
        })
        .catch(() => {
          this.list = []
          this.total = this.sumTime = 0
          this.$message.error('获取数据失败，请重试')
        })
        .then(() => {
          this.$store.dispatch('setLoading', false)
        })
    },
    pageSizeChange (newSize) {
      this.pageIndex = 1
      this.pageSize = newSize
      this.getData()
    },
    pageChange (newPage) {
      this.pageIndex = newPage
      this.getData()
    },
    typeClick () {
      this.pageIndex = 1
      this.getData()
    }
  }
}
</script>

<style lang="scss">
.user-studyRecord-view {
  .statistic {
    text-align: center;
    font-size: 16px;
    line-height: 45px;
    .count {
      font-size: 24px;
      font-weight: bold;
      margin: 0 3px;
    }
    .time {
      font-size: 18px;
      font-weight: bold;
      margin-left: 3px
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/user/studyRecord.vue